export default ({
  group: {
    gateway: {
      id,
    },
  },
}) => id || 'not-set'
